<!--
 * @Description: 商户审核详情组件
 * @Author: gaohc
 * @Date: 2022-11-02 16:43:52
-->
<template>
  <div class="body">
    <el-drawer title="商户审核" :before-close="handleClose" :visible.sync="visible" direction="rtl"
      size="1000px" ref="drawer" withHeader :wrapperClosable="true" @open="initData">
      <div class="review-result-wrap" v-if="mchDetailsData && mchDetailsData.review">
        <mch-review-result v-if="isGlobalAdmin && (!mchDetailsData.review.status ||
          mchDetailsData.review.status == 2)"
          :review="mchDetailsData.review" @handle-review="handleMchReview">
				</mch-review-result>
        <review-history v-else :review="mchDetailsData.review">
        </review-history>
      </div>
      <common-mch-details :mchDetailsData="mchDetailsData" />
    </el-drawer>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import commonMchDetails from "../../../mchmng/components/CommonMchDetails.vue";
import ReviewHistory from "../ReviewHistory.vue";
import MchReviewResult from "./MchReviewResult.vue";

export default {
  name: "MchReviewDetails",
  props: ["visible", "mchId", "isGlobalAdmin"],
  components: {
    "common-mch-details": commonMchDetails,
    "review-history": ReviewHistory,
    "mch-review-result": MchReviewResult,
  },

  data() {
    return {
      mchDetailsData: {},
    };
  },

  methods: {
    handleMchReview(reviewStatus, version) {
      this.$emit("handle-review-attendant", reviewStatus, version);
    },

    getMchReviewDetails() {
      let params = {id: this.mchId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_MERCHANT_REVIEW,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };

      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }
        this.mchDetailsData = result.data;
        this.mchDetailsData.review.reviewHistoryList = result.data.reviewHistoryList;
      });
    },

    initData() {
      this.getMchReviewDetails();
    },

    handleClose() {
      this.mchDetailsData = {};
      this.$emit("close-dialog");
    },
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.review-result-wrap {
  padding: 0 60px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/review/components/mchReviewList/MchReviewDetails.vue